import { render } from "./EditFicheRef.vue?vue&type=template&id=25d2f1b5"
import script from "./EditFicheRef.vue?vue&type=script&lang=js"
export * from "./EditFicheRef.vue?vue&type=script&lang=js"

import "./EditFicheRef.vue?vue&type=style&index=0&id=25d2f1b5&lang=scss"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__